import { addRolesToOrganisationUser, updateOrganisationUser } from '@infuse/api/iam/organisation';
import { useGenericUpdateUser } from '@infuse/iam/user/mutations';

export const useUpdateOrganisationUser = () =>
  useGenericUpdateUser({
    apiFn: updateOrganisationUser,
    roleApiFn: addRolesToOrganisationUser
  });
